import { shuffleArray } from 'utils/transforms';
import { PlanName } from './Plan';

enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
  FORCED_SKIP = 'forced_skip',
  INACTIVE = 'inactive',
  PAUSED = 'paused',
  RETURNING = 'returning',
  SKIPPED = 'skipped',
  SUSPENDED = 'suspended',
}

type Extras = {
  dinner: number;
  breakfast: number;
  lunch: number;
};

type Coupon = { free_shipping: boolean, allowed_plans: PlanName[] };

type SignupSummary = {
  shipping: {
    shipping_surcharge_after_discount: string;
    value: string;
    shipping_surcharge: string;
    shipping_fee_after_discount: string;
    shipping_fee: string;
    free: boolean;
  },
  // TODO: what is the difference between value & coupon_value?
  discount: {
    value: number;
    type: string;
    coupon_name: string;
    coupon_count: number;
    coupon_discount_type: 'dollar_off' | 'percentage_off';
    coupon_value: number;
  },
  total_price: number;
  sales_tax: number;
  sales_tax_after_discount: number;
  box_total: number;
  delivery_date: string;
  credit: string;
  crd_fee: number;
  crd_fee_after_discount: number;
  oauth_info: Record<string, string>;
};

interface ISubscription {
  id: number;
  status: SubscriptionStatus;
  plan: PlanName;
  coupon: Coupon;
  extras: Extras;
  returning_reactivation_on: string;
  next_scheduled_order_date: Date;
  signup_summary: SignupSummary;
  delivery_frequency: string;
  is_diversified: boolean;
}

type Option = {
  id: string;
  label: string;
};

const pauseOptions = [
  {
    id: '6',
    label: '6 weeks',
  },
  {
    id: '8',
    label: '8 weeks',
  },
  {
    id: '10',
    label: '10 weeks',
  },
];

const cancelOptions = [
  {
    id: 'dietary',
    label: 'Meals don’t match nutrition goals/needs',
  },
  {
    id: 'recipes',
    label: "Didn't like meal/recipe choices",
  },
  {
    id: 'ingredients',
    label: "Ingredient quality didn't match expectations",
  },
  {
    id: 'flavor_taste',
    label: "Didn't enjoy the flavor/taste of meals",
  },
  {
    id: 'expensive',
    label: 'Can no longer afford',
  },
  {
    id: 'cooking_time',
    label: 'Meal Kit prep was too long',
  },
  {
    id: 'packaging_environment',
    label: 'Packaging impact on environment',
  },
  {
    id: 'packaging_quality',
    label: 'Packaging quality',
  },
  {
    id: 'delivery',
    label: 'Delivery issues',
  },
  {
    id: 'my_own',
    label: 'Prefer to shop, prep, and cook myself',
  },
  {
    id: 'not_kid_friendly',
    label: 'Meals not kid/family friendly',
  },
  {
    id: 'need_variety',
    label: 'Want more variety',
  },
  {
    id: 'portions_too_small',
    label: 'Meal portions too small',
  },
  {
    id: 'gift_credits',
    label: 'Used gift credit',
  },
  {
    id: 'less_meals',
    label: 'The thrill is gone',
  },
];

const getOptionsforCancel = (): Option[] => shuffleArray(cancelOptions)
  .concat([{ id: 'other', label: 'Other' }]);

const getOptionsforPause = (): Option[] => pauseOptions;

export type { ISubscription, SignupSummary };
export { SubscriptionStatus, getOptionsforCancel, getOptionsforPause };
